import { string, object } from 'yup';

export function bankAccountApprovalsFiltersSchema() {
    return object().shape({
        optionFilter: string().typeError('Tipo do filtro precisa ser preenchido.').required('Tipo do filtro: precisa ser preenchido.'),

        filterAlreadyApproved: string().when("optionFilter", {
            is: "filterAlreadyApproved",
            then: string().typeError('Filtro por aprovados precisa ser preenchido.').required('Filtro por aprovados: Precisa ser preenchido.'),
            otherwise: string().nullable()
        }),
        filterOnlyMine: string().when("optionFilter", {
            is: "filterOnlyMine",
            then: string().typeError('Filtro apenas os meus precisa ser preenchido.').required('Filtro apenas os meus: Precisa ser preenchido.'),
            otherwise: string().nullable()
        }),
    });
}

export const defaultValuesBankAccountApprovalsFilters = () => {
    return {
        optionFilter: 'filterOnlyMine',
        filterAlreadyApproved: 'true',
        filterOnlyMine: 'false'
    }
};